// extracted by mini-css-extract-plugin
module.exports = {"blens":"styles_blens__X9uCj"};